import React, { useCallback, FC, ReactNode } from 'react'
import styles from 'styles/components/form.module.scss'
import { useDropzone } from 'react-dropzone'

type Props = {
  maxAcceptableFiles: number
  handleAcceptedFiles: (files: File[]) => void
  children: ReactNode
}

const ImageDropzone: FC<Props> = (props) => {
  const { maxAcceptableFiles, handleAcceptedFiles, children } = props

  const onDrop = useCallback(
    (acceptedFiles: any) => {
      // FileListをFileの配列に変換
      const files = Array.from(acceptedFiles as FileList)
      // アップロード可能枚数まで絞る
      handleAcceptedFiles(files.slice(0, maxAcceptableFiles))
    },
    [handleAcceptedFiles, maxAcceptableFiles]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div
      className={isDragActive && maxAcceptableFiles > 0 ? styles.dropzone_active : styles.dropzone}
      {...getRootProps()}
    >
      {isDragActive && maxAcceptableFiles > 0 ? (
        <input className={styles.dropzone__input} type="file" accept="image/*, .heic" {...getInputProps()} />
      ) : (
        <input className={styles.dropzone__input} type="file" accept="image/*, .heic" />
      )}
      {children}
    </div>
  )
}

export default ImageDropzone
